
<template>
    <div class="tabs-view">
        <el-tabs class="tabs-view__inner" v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
            <el-tab-pane
                v-for="(item) in editableTabs"
                :key="item.name"
                :label="item.title"
                :name="item.name"
            >
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

  <script>
  /* eslint-disable */
  import store from '@/store';
  import { useRoute } from 'vue-router';
  import { watch } from 'vue';
import router from '@/router';
    export default {
        name:'TabsView',
      data() {
        return {
          editableTabsValue: store.state.edittableTabsValue,
          editableTabs: store.state.edittableTabs,
        }
      },
      methods: {
        removeTab(targetName) {
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);
          
          this.$store.state.edittableTabs = this.editableTabs
          this.$store.state.edittableTabsValue = this.editableTabsValue
          
          this.$store.commit('SAVE_CUR_TAB',{'path':this.editableTabsValue})
          this.$store.commit('SAVE_CUR_TABS',this.editableTabs)
          
          if (this.$router.currentRoute.path != activeName) {
            this.$router.push({path:activeName})
          }
          if (this.$router.currentRoute == null)
          {
            this.$store.commit('ADD_TABS',{
                name:'首页',
                path:'/index'
            })
            
          }
          
          
          
        },
        clickTab(target){
            
            this.$store.commit('SAVE_CUR_TAB',{
                path:target.name
            })
            router.push(target.name)
        }
      },
      mounted(){
        watch(store.state, (state)=>{
            
            this.editableTabs = store.state.edittableTabs
            this.editableTabsValue = store.state.edittableTabsValue
            router.push({path:this.editableTabsValue})
        }, { deep : true,immediate: true})

        // watch(router,(to)=>{
        //   console.log('to',to);
        // }, {deep:true, immediate:true})
      }
      
    }

  </script>
  

<style scoped>
.tabs-view {
    padding: 0;
    background-color: #f5f5f5;
}

.tabs-view__inner {
    margin-bottom: 0;
}

:deep(.el-tabs__header) {
    margin-bottom: 0;
}

:deep(.el-tabs__nav-wrap::after) {
    background-color: #ebeef5;
}

:deep(.el-tabs__item) {
    height: 38px;
    line-height: 38px;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
    background-color: #f5f5f5;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item.is-active) {
    background-color: #f5f5f5;
    border-bottom-color: #f5f5f5;
}

:deep(.el-tabs__content) {
    display: none;
}
</style>
